import React, { useState } from 'react';

import { MarkdownContent } from '@backstage/core-components';

import { Box, Typography, Divider, BoxProps, Link } from '@material-ui/core';

import { InfoDocDialog } from './InfoDocDialog';
import { useStyles } from './styles';

interface ScaffolderFormHeaderProps {
  title: string;
  description?: string;
  variant?: 'h4' | 'h5' | 'h6' | 'body1' | 'body2';
  divider?: boolean;
  boxProps?: Omit<BoxProps, 'marginBottom'>;
  infoDoc?: string;
  infoDocVariant?: 'dialog' | 'drawer';
}

export const ScaffolderFormHeader = (props: ScaffolderFormHeaderProps) => {
  const {
    title,
    description,
    variant = 'h5',
    divider = false,
    boxProps,
    infoDoc,
    infoDocVariant = 'drawer',
  } = props;

  const classes = useStyles();
  const [infoDocDialogOpen, setInfoDocDialogOpen] = useState(false);

  const handleOpenInfoDocDialog = () => {
    setInfoDocDialogOpen(true);
  };

  const handleCloseInfoDocDialog = () => {
    setInfoDocDialogOpen(false);
  };

  return (
    <Box className={classes.formHeaderContainer} {...boxProps}>
      <Box className={classes.flexContainer}>
        <Typography variant={variant}>{title}</Typography>
        {!divider && infoDoc && (
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            className={classes.infoDocDivider}
          />
        )}
        {infoDoc && (
          <Link
            color="secondary"
            variant="subtitle2"
            onClick={handleOpenInfoDocDialog}
            className={classes.infoDocOpenButton}
          >
            Info
          </Link>
        )}
      </Box>
      {divider && <Divider />}
      {description && (
        <MarkdownContent
          className={classes.markdownDescription}
          content={description}
        />
      )}
      <InfoDocDialog
        dialogTitle={title}
        open={infoDocDialogOpen}
        onClose={handleCloseInfoDocDialog}
        infoDoc={infoDoc || ''}
        variant={infoDocVariant}
      />
    </Box>
  );
};
